<script>
  import { createEventDispatcher } from 'svelte';
  import { getAppConfig } from '../../../../common/config/app-config';
  import { getBackgroundColor, getLabelColor, getStr, globalCurrencyTag } from '../../../../common/util';
  import Text from '../../../common/components/Text.svelte';
  import { currentSelectedStoreData, productDetails } from '../../store/pdp_store';
  import BundleBottomButton from '../PdpBundlePromotion/BundleBottomButton.svelte';
  import { getManualBundlePrice } from './ManualBundleCalculator';
  export let currency;
  export let selectedProds;
  export let manualBundleProducts;
  export const pageLabels = null;
  export let preorder = false;

  const { lang } = getAppConfig();

  $productDetails = window['ACC'].config.productDetails;
  $: finalPrice = getManualBundlePrice(selectedProds, manualBundleProducts);
  $: cartItems = selectedProds && selectedProds.length;
  $: learnMore = $productDetails.learnMore;
  const cashBacklabelColor = getLabelColor('extra.product.cashback.cashback');
  const cashBackBackgroundColor = getBackgroundColor('extra.product.cashback.cashback');
  const learnMoreLabelColor = getLabelColor('extra.product.cashback.learn.more');
  const learnMoreBackgroundColor = getBackgroundColor('extra.product.cashback.learn.more');
  const tasheelInstallMonths = ACC.config.unbxdSearchConfig.tasheelInfo.tasheelInstallmentMonths;
  const decimalNumber = ACC.config.currencyDecimal;

  const formatNumber = num => {
    if (num) {
      return Number(Number(num).toFixed(decimalNumber));
    } else {
      return;
    }
  };

  const manualBundleDispatcher = createEventDispatcher();

  function addManualBundleToCart() {
    manualBundleDispatcher('addManualBundleToCart', null);
  }

  $: cfsSelectedStoreData = $currentSelectedStoreData;
  $: code = $productDetails.code;
  $: cfsInStock =
    cfsSelectedStoreData?.stockLevelStatus?.code === 'inStock' ||
    cfsSelectedStoreData?.stockLevelStatus?.code === 'lowStock';
  $: deliveryInStock =
    $productDetails?.homeDeliveryData?.currentCityStockData?.stockLevelStatus?.code === 'inStock' ||
    $productDetails?.homeDeliveryData?.currentCityStockData?.stockLevelStatus?.code === 'lowStock';

  $: addBundleBtnDisable = selectedProds?.includes(code) && !(deliveryInStock || cfsInStock);
</script>

<section class="bundle-bottom" class:preorder-bundle={preorder}>
  {#if finalPrice.finalPrice}
    <section class="bundle-bottom-left">
      <section class="bundle-bottom-left-first">
        <span class="font-weight-regular font-size-md"><Text key="extra.pdp.buybundlelable" /></span>
      </section>
      <section class="bundle-bottom-left-second">
        <span class="font-weight-regular">
          {#if lang == 'en'}{@html globalCurrencyTag}{/if}
          <span class="font-weight-bold">
            {formatNumber(finalPrice.finalPrice)}
          </span>
          {#if lang == 'ar'}{@html globalCurrencyTag}{/if}
          {#if finalPrice.finalTashleelAmount}
            {getStr('or')}
            {@html globalCurrencyTag}
            <span class="font-weight-bold">
              {formatNumber(finalPrice.finalTashleelAmount)}/<Text key="extra.pdp.monthLable" />
            </span>
          {/if}
        </span>
      </section>
    </section>
    {#if finalPrice.finalCashBackPrice && finalPrice.finalCashBackPrice > 0}
      <section class="bundle-bottom-center {!finalPrice?.finalPrice ? 'no-border' : ''}">
        <div class="first-row">
          <div class="amount-text">
            <span class="font-weight-regular">
              <Text key="payJust" />
              {@html globalCurrencyTag}
            </span>
            <span class="font-weight-bold">
              {formatNumber(finalPrice?.finalPrice - finalPrice.finalCashBackPrice)}
            </span>
          </div>
          <div class="tag-wrapper" style:color={cashBacklabelColor} style:background-color={cashBackBackgroundColor}>
            {@html globalCurrencyTag}
            {finalPrice.finalCashBackPrice}
            <Text key="extra.product.cashback.cashback" />
          </div>
        </div>
        <div class="second-row">
          <div class="text-wrapper">
            {#if finalPrice.finalTashleelCashbackAmount}
              <span class="font-weight-regular font-size-md">
                <!-- <Text key="or" /> 
               {currency}
            <span class="font-weight-bold">
              {formatNumber(finalPrice.finalTashleelCashbackAmount)}/<Text key="extra.pdp.month" />
            </span>
            <Text key="for" />
            {tasheelInstallMonths}
            <Text key="extra.months.text" /> -->
                <Text
                  key="extra.pdp.fbt.tasheel"
                  args={[
                    globalCurrencyTag,
                    `${formatNumber(finalPrice.finalTashleelCashbackAmount)}`,
                    tasheelInstallMonths,
                  ]}
                />
              </span>
            {/if}
            <span class="link">
              <a
                href={learnMore?.lableUrl}
                class="learn-more-link"
                style:color={learnMoreLabelColor}
                style:background-color={learnMoreBackgroundColor}
              >
                <Text key="extra.product.cashback.learn.more" />
              </a>
            </span>
          </div>
        </div>
      </section>
    {/if}
  {/if}

  <section class="bundle-bottom-right">
    <!--  commented out because of MAVD-3954
        <BundleBottomButton
        label={getStr('extra.viewDetailsLable')}
        type={"primary"}
        variant={"outlined"}
        width={"75px"}
      /> -->
    <BundleBottomButton
      on:click={() => addManualBundleToCart()}
      label={`${getStr('extra.pdp.addalltocartlable')} (${cartItems})`}
      type="secondary"
      variant="solid"
      width="200px"
      disabled={!finalPrice?.finalPrice || addBundleBtnDisable}
    />
  </section>
</section>

<style lang="scss">
  @import '../../../common/styles/colors.new.scss';

  .bundle-bottom {
    display: flex;

    &-left {
      margin-right: 16px;
      &-first {
        line-height: 18px;
        color: $neutral-dark-01;
      }

      &-second {
        font-size: 24px;
        line-height: 26px;
        color: $neutral-dark-01;
        .font-weight-bold {
          line-height: 28px;
        }
      }
    }

    &-center {
      display: flex;
      flex-direction: column;
      padding-left: 16px;
      border-left: 1px solid $secondary-gray-02;
      &.no-border {
        border-left: none;
      }
      .first-row {
        display: flex;
        gap: 8px;
        .amount-text {
          font-size: 24px;
          line-height: 26px;
          font-weight: 400;
        }
        .tag-wrapper {
          color: $extraTagTextColor;
          background: $extraTagBg;
          padding: 2px 5px;
          border-radius: 3px;
          font-weight: 700;
          font-size: 11px;
          line-height: 12px;
          height: max-content;
          @include desktop-min-width {
            font-size: 10px;
            padding: 6px 8px 4px;
            border-radius: 5px;
          }
        }
      }
      .second-row {
        display: flex;
        gap: 4px;
        margin-top: 4px;
        .text-wrapper {
          font-size: 16px;
          line-height: 18px;
          font-weight: 400;
        }
        .link {
          font-size: 14px;
          line-height: 16px;
          font-weight: 500;
          color: $icon-only-icon-blue;
          a:link {
            text-decoration: none;
          }
          a:visited {
            text-decoration: none;
          }
          a:hover {
            text-decoration: none;
          }
          a:active {
            text-decoration: none;
          }
        }
      }
    }
    &:not(.preorder-bundle) {
      margin-top: 72px;
      @include desktop-min-width {
        flex-direction: column;
        gap: 26px;
        margin-top: 25px;
      }
      .bundle-bottom-right {
        :global(.extra-btn .btn) {
          @include desktop-min-width {
            padding: 20px;
            font-size: 20px;
            line-height: 18px;
          }
        }
      }
    }
    &.preorder-bundle {
      margin-top: 60px;
      .bundle-bottom-right {
        display: flex;
        gap: 12px;
        align-items: center;
        margin-left: auto;
      }
    }
  }
  :global {
    .bundle-bottom {
      .mdc-ripple-upgraded {
        height: 100%;
      }
    }
  }
</style>
